import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';

class listKissInvitedEntitysCtrl {
    /* @ngInject */
    constructor(
        $state,
        logger,
        $translate,
        KISS_INVITED_ENTITY,
        KissUserSvc,
        PrincipalSvc,
        $scope,
        InvitedEntityFilter,
        invitedEntitySvc
    ) {
        this.$state = $state;
        this.logger = logger;
        this.$translate = $translate;
        this.KISS_INVITED_ENTITY = KISS_INVITED_ENTITY;
        this.KissUserSvc = KissUserSvc;
        this.PrincipalSvc = PrincipalSvc;
        this.$scope = $scope;
        this.InvitedEntityFilter = InvitedEntityFilter;
        this.invitedEntitySvc = invitedEntitySvc;
    }

    $onInit() {
        var defaultCellTemplate =
            '<a class="grid-cell-link" ui-sref="app.invitedentity.edit({ id:row.entity.id, type:row.entity.entityType })"><div class="ui-grid-cell-contents ui-grid-cursor-pointer" ng-click="grid.appScope.$ctrl.view(row)">{{COL_FIELD CUSTOM_FILTERS}}</div></a>';
        // ---------------
        // Data API
        // ---------------
        // Recherche
        this.statusList = this.KISS_INVITED_ENTITY.invited_entity.status;
        this.langs = this.PrincipalSvc.getLangs();
        this.entityType = this.KISS_INVITED_ENTITY.invited_entity.type;

        this.searchData =
            this.invitedEntitySvc.getinvitedEntityListFilter() && this.keepSearchData
                ? this.invitedEntitySvc.getinvitedEntityListFilter()
                : new this.InvitedEntityFilter();

        // Liste
        this.gridOptions = {
            columnDefs: [
                {
                    name: 'legalEntity.name',
                    displayName: 'kiss_invited_entity.list.name',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'legalEntity.getIdentifiant()',
                    displayName: 'kiss_invited_entity.list.ident',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getEntityTypeLabel()',
                    displayName: 'kiss_invited_entity.list.type',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getCountryLabel()',
                    displayName: 'kiss_invited_entity.list.country',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getLangLabel()',
                    displayName: 'kiss_invited_entity.list.lang',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'invoiceSenderEmail',
                    displayName: 'kiss_invited_entity.list.email',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                },
                {
                    name: 'getStatusLabel()',
                    displayName: 'kiss_invited_entity.list.status',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer',
                    width: 80,
                },
                {
                    name: 'n/a',
                    displayName: 'kiss_invited_entity.list.relations',
                    headerCellFilter: 'translate',
                    cellTemplate:
                        '<div class="ui-grid-cursor-pointer text-center" ng-hide="row.entity.invitedEntityTypes === \'INVITED\' || !row.entity.hasRelation" ng-click="grid.appScope.$ctrl.viewRelations(row)">' +
                        '<i class="fa fa-search"></i></div>',
                    cellClass: 'pointer',
                    width: 110,
                },
            ],
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            useExternalSorting: true,
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                // Sorting & pagination
                gridApi.core.on.sortChanged(this.$scope, (grid, sortColumns) => {
                    sortColumns = _.map(sortColumns, col => this.convertSort(col));
                    if (sortColumns && sortColumns.length > 0) {
                        this.searchData.setSort(sortColumns);
                    } else {
                        this.searchData.resetSort();
                    }
                    this.search();
                });
                gridApi.pagination.on.paginationChanged(this.$scope, (page, size) => {
                    this.searchData.setPageSize(size);
                    this.searchData.setPage(page - 1);
                    this.search();
                });
            },
        };

        this.preparedSearchFilter = {};
        this.headers = [];

        this.clearFilter = true;

        if (!this.searchData.preparBeforeSearch) {
            this.searchData = new this.InvitedEntityFilter();
            this.invitedEntitySvc.initSessionStorage();
        }
        //initialiser le filtre de recherche pour l'export
        this.preparedSearchFilter = this.searchData.preparBeforeSearch();

        //recuperer la liste des headers pour l'export
        this.headers = _.map(this.gridOptions.columnDefs, column => {
            return this.$translate.instant(column.displayName);
        });
    }

    convertSort(col) {
        var columnField = _.find(this.KISS_INVITED_ENTITY.invited_entity.columnFieldMap, { field: col.field });
        if (col && col.sort) {
            return {
                direction: angular.uppercase(col.sort.direction),
                property: columnField ? columnField.property : col.field,
                priority: col.sort.priority,
            };
        }
        return {};
    }

    paginationChanged(page, size) {
        this.searchData.setPageSize(size);
        this.searchData.setPage(page - 1);
        this.search();
    }

    search() {
        let initialEntityTypeValue = _.cloneDeep(this.searchData.entityType.value);

        if(this.searchData.entityType.value === 'INVITED' ){
            this.searchData.invited = true;
            this.searchData.entityType.value = null
        }else{
            this.searchData.invited = false;
        }
        var searchResult = this.invitedEntitySvc.searchFiltredInvitedEntity(this.searchData);
        this.kissInvitedEntityPromise = searchResult;
        searchResult.then(
            pageSellers => {
                this.gridOptions.data = pageSellers.invitedEntities;
                this.gridOptions.totalItems = pageSellers.totalItems;
                //enregistrer le filtre de recherche formaté pour l'export
                this.preparedSearchFilter = this.searchData.preparBeforeSearch();
            },
            (/*error*/) => {
                this.logger.error('error.search');
            }
        );

        this.searchData.entityType.value = initialEntityTypeValue;
    }

    clearForm() {
        // Reset data
        this.searchData = new this.InvitedEntityFilter();
        // Reset form
        this.form.$setPristine();
        this.search();
    }

    view() {
        this.clearFilter = false;
    }

    viewRelations(row) {
        this.clearFilter = false;
        const routeName =
            row.entity.entityType === 'SELLER'
                ? 'app.invitedentity.sellerrelations'
                : 'app.invitedentity.buyerrelations';
        this.$state.go(routeName, { id: row.entity.id });
    }

    /**
     * Fournit la hauteur optimale de la grid en fonction du nombre d'element par page.
     */
    getGridHeight() {
        return gridHeight(this.gridApi);
    }

    isBuyer() {
        return (
            this.searchData.entityType &&
            this.searchData.entityType.value === this.KISS_INVITED_ENTITY.invited_entity.type[1].value
        );
    }
}

angular.module('app.invitedentity').component('listKissInvitedEntitys', {
    templateUrl: require('./list-invited-entity.html'),
    controller: listKissInvitedEntitysCtrl,
    bindings: {
        keepSearchData: '<',
    },
});
